import Enum from 'enum';

export const Resources = new Enum({
  ShiftOpeningsBulk: 'shift_openings/bulk',
  ShiftOpenings: 'shift_openings',
  ShiftOpening: 'shift_openings/:shiftOpeningId',
  ShiftOpeningRate: 'shift_openings/:shiftOpeningId/rate',
  ShiftAssignments: 'shift_assignments',
  ShiftAssignment: 'shift_assignments/:shiftAssignmentId',
  ShiftRequest: 'shift_requests/:shiftRequestId',
  ShiftRequests: 'shift_requests',
  ShiftRequestStatus: 'shift_requests/:shiftRequestId/status',
  ShiftShiftRequests: 'shifts/:shiftId/requests',
  ShiftCancellationReasons: 'cancellation-reasons',
  // Direct Connect
  ShiftDispatch: 'shifts/:shiftId/shift-dispatch',
  ShiftDispatchBulk: 'shifts/:shiftId/shift-dispatch/bulk',
  ShiftDispatches: 'shifts/:shiftId/shift-dispatches',
  ShiftDispatchShiftEligibilityData: 'shifts/shift-dispatch/shift-eligibility-data/:facilityId',
  ShiftDispatchConfig: 'shifts/shift-dispatch/config',
  ShiftBroadcastLimit: 'shifts/shift-dispatch/shift-broadcast-limit/:facility',
  ShiftAdminAssist: 'shifts/:shiftId/admin_assist',
  ShiftDetailsAdminAssist: 'shifts/admin_assist',
  ShiftProfessionalsAvailableNow: 'shifts/:shiftId/professionals-available-now',
  SuggestedProviders: 'shifts/:shiftId/sorted_professionals',
  ShiftProfessionals: 'shifts/professionals',
  // Block Shifts
  BlockShift: 'facilities/:facilityId/block-shifts/:blockId',
  BlockShifts: 'facilities/:facilityId/block-shifts/:shiftBlockId',
  CreateBlockShifts: 'facilities/:facilityId/block-shifts',
  BlockShiftsCalculateRates: 'facilities/:facilityId/block-shifts/calculate-rates',
});
